<template>
    <div class="firstCon">
      <!--    导航栏-->
      <div class="nav">
        <img class="logo" src="../assets/logo.png" alt="" @click="goto(1)">
        <div class="menu-btn dh"
             :class="{'active':isShowLeft}"
             @click="isShowLeft=!isShowLeft">
          <div class="menu-burger-wrapper">
            <div class="trigger menu-trigger">
              <div class="menu-burger icon-wrapper">
                <div class="line line-top"></div>
                <div class="line line-center"></div>
                <div class="line line-bottom"></div>
              </div>
            </div>
          </div>
        </div>

        <transition name="fade">
          <div class="mUl" v-if="isShowLeft">
            <span @click="goto(1)">{{$t('top[0]')}}</span>
            <span @click="goto(2)">{{$t('top[1]')}}</span>
            <span @click="goto(3)">{{$t('top[2]')}}</span>
            <span @click="goto(4)">{{$t('top[3]')}}</span>
            <span @click="goto(5)">{{$t('top[4]')}}</span>
            <span @click="goto(6)">{{$t('top[5]')}}</span>
            <span @click="change('zh-CN')">中文版</span>
            <span @click="change('en')">ENGLISH</span>
            <a href="mailto:name@email.com"><i class="iconfont  icon-youxiang email"></i></a>
          </div>
        </transition>


        <ul class="oneUl">
          <li @click="goto(1)">
            <span :style="num===1?colorStyle:''">{{$t('top[0]')}}</span>
            <span  class="line" :style="num===1?showStyle:''"></span>
          </li>
          <li @click="goto(2)">
            <span :style="num===2?colorStyle:''">{{$t('top[1]')}}</span>
            <span  class="line" :style="num===2?showStyle:''"></span>
            <div class="productItem animated fadeInRight">
              <a @click="gotoAbout(0)">·&nbsp;{{$t('aboutList[0]')}}</a>
              <a @click="gotoAbout(1)">·&nbsp;{{$t('aboutList[1]')}}</a>
              <a @click="gotoAbout(2)">·&nbsp;{{$t('aboutList[2]')}}</a>
            </div>
          </li>
          <li @click="goto(3)">
            <span :style="num===3?colorStyle:''">{{$t('top[2]')}}</span>
            <span  class="line" :style="num===3?showStyle:''"></span>
            <div class="productItem animated fadeInRight">
              <a @click="gotoPro(index,item.ID)" v-for="(item,index) in proList" :key="index">·&nbsp;{{item.CALLED}}</a>
            </div>
          </li>
          <li @click="goto(4)">
            <span :style="num===4?colorStyle:''">{{$t('top[3]')}}</span>
            <span  class="line" :style="num===4?showStyle:''"></span>
            <div class="productItem animated fadeInRight">
              <a @click="gotoTe(0)">·&nbsp;{{$t('teList[0]')}}</a>
              <a @click="gotoTe(1)">·&nbsp;{{$t('teList[1]')}}</a>
              <a @click="gotoTe(2)">·&nbsp;{{$t('teList[2]')}}</a>
            </div>
          </li>
          <li @click="goto(5)">
            <span :style="num===5?colorStyle:''">{{$t('top[4]')}}</span>
            <span  class="line" :style="num===5?showStyle:''"></span>
            <div class="productItem animated fadeInRight">
              <a @click="gotoMark(0)">·&nbsp;{{$t('mkList[0]')}}</a>
              <a @click="gotoMark(1)">·&nbsp;{{$t('mkList[1]')}}</a>
              <a @click="gotoMark(2)">·&nbsp;{{$t('mkList[2]')}}</a>
            </div>
          </li>
          <li @click="goto(6)">
            <span :style="num===6?colorStyle:''">{{$t('top[5]')}}</span>
            <span  class="line" :style="num===6?showStyle:''"></span>
            <div class="productItem animated fadeInRight">
              <a @click="gotoSup(0)">·&nbsp;{{$t('spList[0]')}}</a>
              <a @click="gotoSup(1)">·&nbsp;{{$t('spList[1]')}}</a>
              <a @click="gotoSup(2)">·&nbsp;{{$t('spList[2]')}}</a>
            </div>
          </li>
        </ul>
        <div class="key animated fadeInRightBig" v-if="isShow">
          <input type="text" placeholder="KeyWords" v-model="value" @keyup.enter="gotoSearch">
          <i class="iconfont icon-guanbi a" @click="noShow"></i>
        </div>
        <div class="threeImg" v-else>
          <div class="firstImg">
           <i class="iconfont icon-diqiu little email"></i>
            <div class="language animated fadeIn" >
              <span @click="change('zh-CN')">中文版</span>
              <span @click="change('en')">ENGLISH</span>
            </div>
          </div>
          <i class="iconfont icon-iconset0157 email" @click="showKey"></i>
          <a href="mailto:name@email.com"><i class="iconfont  icon-youxiang email"></i></a>

        </div>
      </div>
    </div>
</template>

<script>
  import { setup } from "../local/index"
  import {getProductstypeUrl2,getProductsUrl } from '../util/lang'
    export default {
        name: "first",
      data(){
          return{
            bShow:true,
            value:'',
            colorStyle:{color:'#C7000C'},
            showStyle:{display:'block'},
            isShow:false,
            proList:[],
            isShowLeft:false,
          }
      },
      props:["num"],
      mounted(){
          this.getPro()
      },
      methods:{
        gotoSearch(){
          if(this.value==='')
          {
            this.$notify({
              title: 'Sorry',
              message: 'Please input the product name',
              offset: 100
            });
          }else{
            this.$router.push({path:'/proSearch',query:{value:this.value}})
            this.$router.go(0)
          }
        },
        getPro(){
          this.$nextTick(()=>{
            const url = `${getProductstypeUrl2( this.$i18n.locale)}`
            this.$axios.get(url).then(res => {
              this.proList=res.data.slice(1,6)
            })
          })
        },
          goto(index){
            if(index===1){
              this.$router.push({path:'/home'})
            }
            else if(index===2){
              this.$router.push({path:'/about'})
            }else if(index===3){
              this.$router.push({path:'/product'})
            }else if(index===4){
              this.$router.push({path  :'/tech'})
            }else if(index===5){
              this.$router.push({path:'/market'})
            }else {
              this.$router.push({path:'/support'})
            }
          },
        gotoAbout(index){
          this.$router.push({path:'/about',query:{select:index}})
        },
        gotoPro(index,id){
          this.$router.push({path:'/product',query:{select:index,id:id}})
        },
        gotoTe(index){
          this.$router.push({path:'/tech',query:{select:index}})
        },
        gotoMark(index){
          this.$router.push({path:'/market',query:{select:index}})
        },
        gotoSup(index){
          this.$router.push({path:'/support',query:{select:index}})
        },
        noShow(){
          this.isShow=false
        },
        showKey(){
          this.isShow=true
        },
        change(n){
          this.$i18n.locale = n
          window.localStorage.setItem('language', n)
          setup(n);
          this.$router.go(0)
        }
      }
    }
</script>


<style lang="scss" scoped>
.firstCon{
  width:100%;
  .nav{
    width:100%;
    height:80px;
    min-width: 1280px;
    z-index: 999;
    padding-top: 30px;
    display: flex;
    flex-direction: row;
    top:0;
    border-bottom: 1px solid rgba(255,255,255,0.2);
    .logo{
      width:200px;
      height:40px;
      margin-left: 10%;
      margin-top: 5px;
      cursor: pointer;
    }
   .dh{
     display: none;
   }
    .menu-btn {
      display: none;
      justify-content: center;
      align-items: center;
      width: 40px;
      height: 25px;
      margin-left: 12px;
      cursor: pointer;
      .menu-burger-wrapper {
        width: 20px;
        height: 20px;

        .menu-trigger {
          position: relative;
          width: 100%;
          height: 100%;

          .menu-burger {
            width: 100%;
            height: 100%;
            position: relative;
            transition: transform 0.4s;

            .line {
              background-color: black;
              position: absolute;
              left: 0;
              width: 100%;
              height: 1px;
              transform-origin: 50% 50%;
              transition: transform 0.5s 0.08s,background-color 0.8s,top 0.5s 0.08s,left 0.3s,opacity 0.5s,width 0.6s 0.05s;
            }
            .line-top {
              top: 0;
              width:50%;
            }
            .line-center {
              top: 50%;
              width: 100%;
            }
            .line-bottom {
              top: 100%;
              width:50%;
            }
          }
        }
      }
    }

    .menu-btn.active .menu-burger-wrapper .menu-trigger .menu-burger {
      transform: rotate(90deg);
    }

    .menu-btn.active .menu-burger-wrapper .menu-trigger .menu-burger .line-top {
      top: 50%;
      width:100%;
      transform: rotate(45deg) translate(0, -50%);
    }
    .menu-btn.active .menu-burger-wrapper .menu-trigger .menu-burger .line-center {
      opacity: 0;
      left: -5px;
      width: 0;
    }
    .menu-btn.active .menu-burger-wrapper .menu-trigger .menu-burger .line-bottom {
      top: 50%;
      transform: rotate(-45deg) translate(0, -50%);
      width: 100%;
    }

    .menu-btn:hover .menu-burger-wrapper .menu-trigger .menu-burger .line-top {
      width: 100%;
    }
    .menu-btn:hover .menu-burger-wrapper .menu-trigger .menu-burger .line-bottom{
      width: 100%;
    }

    .mUl{
      display: none;
    }
    .oneUl{
      width:50%;
      list-style: none;
      height:100%;
      margin-top: 0;
      margin-left: 5%;
      padding-inline-start: 0px;
      li{
        float: left;
        color:#0C3665;
        font-size: 18px;
        margin-left: 8%;
        cursor: pointer;
        transition:color 2s;
        -webkit-transition:color 2s ;
        line-height: 50px;
        position: relative;
        height:100%;
        letter-spacing: 1px;
        .line{
          position: absolute;
          bottom: 0;
          display: none;
          height:2px;
          width:0;
          left: -5%;
          background-color: #C7000C;
          animation:mymove 600ms;;
          /*Safari 和 Chrome*/
          -webkit-animation:mymove 600ms ;
          animation-fill-mode: forwards;
        }
        .productItem{
          position: absolute;
          top:100%;
          background-color: white;
          flex-direction: column;
          display: none;
          z-index: 9999;
          width:500%;
          a{
            font-size: 14px;
            transition:color 1s;
            -webkit-transition:color 1s ;
            font-weight: bold;
          }
          a:hover{
            color:#C7000C;
          }
        }
        .productItem::before{
          width: 10000px;
          position: absolute;
          top:0;
          height: 100%;
          background:white;
          content: '';
          visibility: visible;
          opacity: 1;
          transition: all .5s;
          left:100%;
          z-index: 9999;
        }
        .productItem::after{
          width:10000px;
          position: absolute;
          top: 0;
          height: 100%;
          background: white;
          content: '';
          visibility: hidden;
          opacity: 1;
          transition: all .5s;
          right:100%;
          z-index: 9999;
        }
        @keyframes myMove {
          from {width:0;}
          to {width:120%;}
        }
        @-webkit-keyframes mymove /*Safari 和 Chrome*/
        {
          from {width:0;}
          to {width:120%;}
        }
      }
      li:hover,li:hover .line{
        color:#C7000C;
        display: block;
      }
      li:hover .productItem, li:hover .productItem::after{
        display: flex;
        visibility: visible;
      }
    }
    .threeImg{
      display: flex;
      flex-direction: row;
      a{
        padding-top: 12px;
      }
      .firstImg{
        position: relative;
        .little{
         line-height: 50px;
        }
        img{
          height:28px;
          width:28px;
        }
        .language{
          display: none;
          position: absolute;
          width:120px;
          border-radius: 5%;
          background-color: rgba(255,255,255,.5);
          padding-bottom: 20px;
          padding-top: 10px;
          top:80px;
          left: -20px;
          z-index: 99999;
          span{
            display: inline-block;
            height:40px;
            width:100%;
            text-align: center;
            line-height: 40px;
            cursor: pointer;
            font-size: 14px;
            transition:color 2s;
            -webkit-transition:color 2s ;
          }
          span:first-child{
            border-bottom: 1px solid rgba(0,0,0,.2);
          }
          span:hover{
            color:#0C3665;
          }
        }
      }
      .firstImg:hover .language{
        display: inline-block;
      }
      img{
        height:20px;
        cursor: pointer;
        margin-left: 25px;
        margin-top: 12px;
      }
      .second{
        margin-top: 15px;
      }
      .email{
        font-size:23px;
        margin-top: 13px;
        margin-left: 20px;
        cursor: pointer;
        color:#0C3665;
        transition: color 2s;
      }
      .email:hover{
        color:red;
      }
    }
    .key{
      position: relative;
      width:12%;
      height:40px;
      padding-top: 10px;
      border-bottom: 1px solid rgba(0,0,0,0.2);
      cursor: pointer;
      span{
        position: absolute;
        left: 0;
      }
      input{
        width:80%;
        position: absolute;
        border: none;
        height:30px;
        font-family: light;
      }
      input:focus{
        outline: none;
      }
      .a{
        position: absolute;
        right:10px;
       line-height: 35px;
        z-index: 999;
        font-size: 25px;
        color:#0C3665;
      }
    }
  }
  @media screen and (max-width: 1680px){
    .nav{
      ul{
        margin-left: 0;
        width:60%;
      }
    }
  }
  @media screen and (max-width:1440px){
    .nav{
      .oneUl{
       li{
         margin-left: 6%;
       }
      }
    }
  }
  @media screen and (max-width:768px){
   .nav{
     min-width: 100%;
     .logo{
       margin-left: 2%;
     }
     ul{
       margin-left: 2%;
       li{
         margin-left: 3%;
         span{
           font-size: 14px;
         }
       }
     }
   }
  }
  @media screen and (max-width:450px){
   .nav{
     .menu-btn{
       display: flex;
     }
     ul{
       display: none;
     }
     .key{
    display: none;
     }
     .threeImg{
       display: none;
     }
     .dh{
       display: block;
       height:30px;
       position: absolute;
       right:5%;
       top:35%;
     }
     .mUl{
       width:80%;
       position: fixed;
       top:0;
       left: 0;
       height:100vh;
       padding-top: 30px;
       display: flex;
       flex-direction: column;
       background-color: black;
       text-align: center;
       span{
         display: inline-block;
         width:100%;
         height:50px;
         color:white;
         font-size: 14px;
         line-height: 50px;
       }
       .email{
         color:white;
         font-size: 30px;
       }
     }
   }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/first.vue